<template>
  <div class="about">
    <nav-exhibition :currentIndex="7"/>
    <!--头部介绍文字-->
     <div class="perform-main-content">
    	 <div class="perform-main-title">WIFFA货代人演艺平台</div>
    	 <div class="perform-main-time">首场展示：2020-09-08 15:00-18:00</div>
    	  <div class="perform-main-text">
    	  	<p>WIFFA货代人演艺平台是大连万发联合航贸科技有限公司开发的针对货代大家庭热爱生活、热爱文艺的同行量身打造的文艺表演在线展示的舞台。</p>
    	  	<p>我们货代联合平台的成员可以分享文艺才艺的表演，以口岸为单位，定期举办文艺活动，有益身心健康。通过文艺表演内容运营激活私域流量，接入腾讯、百度、阿里、Linkedin等外部资源实现云引流；通过实时在线直播、视频、音频和自动化客服等互动技术，让观众、货代人之间形成娱乐互动。</p>
    	    <p>不仅如此，我们还原创了货代人自己的歌曲，通过网络评选，选出最优美、有力的货代人之歌。每次活动前，所有人同唱一首歌。那是我们共同的歌，共同的音律带动共同的心跳，迈向共同的目标。</p>
    	    <p>同时文艺演艺的环节，小范围来说，可以全方位的了解企业公司员工的风貌，通过员工风貌，更深切的了解公司。延长到口岸单位，每个口岸城市的会员们，在口岸秘书处的带领下线下和线上同时举行文艺活动，增长友谊，加强合作，共筑三观，彰显货代人的风采。</p>
    	  </div> 
    </div>
    
    <!--视频--start-->    
    <ul class="videolist">
					<!--list--start-->
					<li>
					
							<div class="mainVideo">
								<video class="video-js vjs-default-skin" controls preload="none" width="590" height="325" poster="@/assets/video13.jpg" loop>
									<source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs4.mp4" type='video/mp4' />
								</video>
							</div>
							<!--<div class="peresonName"><span>何朱安</span><span>董事长</span></div>
							<div class="companyName">环集供应链管理股份有限公司 </div>-->
					
					</li>
					<li>
					
							<div class="mainVideo">
								<video class="video-js vjs-default-skin" controls preload="none" width="590" height="325" poster="@/assets/video16.jpg" loop>
									<source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs5.mp4" type='video/mp4' />
								</video>
							</div>
							<!--<div class="peresonName"><span>乐振天</span><span>董事长</span></div>
							<div class="companyName">宁波天时利国际货运代理有限公司</div>-->
						
					</li>
					<li>
						
							<div class="mainVideo">
								<video class="video-js vjs-default-skin" controls preload="none" width="590" height="325" poster="@/assets/video5.jpg" loop>
									<source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs1.mp4" type='video/mp4' />
								</video>
							</div>
						
					</li>
					<li>
						
							<div class="mainVideo">
								<video class="video-js vjs-default-skin" controls preload="none" width="590" height="325" poster="@/assets/video15.jpg" loop>
									<source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs7.mp4" type='video/mp4' />
								</video>
							</div>
						
					</li>
			</ul>
  
    <!--视频--end-->
    
    <!--备案tab切换页--start-->
        <div class="perform-forum-box">
        	   <ul class="perform-forum-tabs">
					     <li class="tabs-active">推荐主播</li>
					     <!--<li>推荐经纪人</li>-->
				     </ul>
			      <div class="perform-tab-content"> 
			      	  <ul>
			      	  	<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-box-top">
			      	  		  		 <div class="perform-list-person-left"><img src="@/assets/anchor5.jpg" alt="" /></div>
			      	  		  	   <div class="perform-list-person-right">
			      	  		  		   <div class="perform-list-person-title">董小白 <span>美妆美食，击剑选手。偶然进入货代科技行业，用运动员的拼搏精神在货代业播出更多收获。</span></div>
			      	  		  		   <div class="perform-list-person-info">大连万发联合航贸科技有限公司</div>
			      	  		  		   <div class="perform-order-num">当前已经有50人观看</div>
			      	  		  	   </div>
			      	  		  	</div>
			      	  		  	
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  		  	 
			      	  		  </div>
			      	  		  
			      	  		  <div class="perform-list-video">
                           <div class="mainVideoSmall">
								            <video class="video-js vjs-default-skin" controls preload="none" width="350" height="220" poster="@/assets/video7.jpg" loop>
									           <source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs4.mp4" type='video/mp4' />
								           </video>
							             </div>
			      	  		  </div>
			      	  		  
			      	  	  </a>
			      	  	</li>
			      	  	
			      	  	
			      	  	<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-box-top">
			      	  		  		 <div class="perform-list-person-left"><img src="@/assets/anchor2.jpg" alt="" /></div>
			      	  		  	   <div class="perform-list-person-right">
			      	  		  		   <div class="perform-list-person-title">王妍 <span>多年货代操作经验，细心专业。</span></div>
			      	  		  		<div class="perform-list-person-info">大连万发联合航贸科技有限公司</div>
			      	  		  		   <div class="perform-order-num">当前已经有50人观看</div>
			      	  		  	   </div>
			      	  		  	</div>
			      	  		  	
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  		  	 
			      	  		  </div>
			      	  		  
			      	  		  <div class="perform-list-video">
                           <div class="mainVideoSmall">
								            <video class="video-js vjs-default-skin" controls preload="none" width="350" height="220" poster="@/assets/video11.jpg" loop>
									           <source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs6.mp4" type='video/mp4' />
								           </video>
							             </div>
			      	  		  </div>
			      	  		  
			      	  	  </a>
			      	  	</li>
			      	  	
			      	  	
			      	  	<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-box-top">
			      	  		  		 <div class="perform-list-person-left"><img src="@/assets/anchor3.jpg" alt="" /></div>
			      	  		  	   <div class="perform-list-person-right">
			      	  		  		   <div class="perform-list-person-title">刘宇政 <span>媒体出身，用文字和声音打通行业链条，最佳运营者。</span></div>
			      	  		  		   <div class="perform-list-person-info">中国国际海运网</div>
			      	  		  		   <div class="perform-order-num">当前已经有50人观看</div>
			      	  		  	   </div>
			      	  		  	</div>
			      	  		  	
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  		  	 
			      	  		  </div>
			      	  		  
			      	  		  <div class="perform-list-video">
                           <div class="mainVideoSmall">
								            <video class="video-js vjs-default-skin" controls preload="none" width="350" height="220" poster="@/assets/video12.jpg" loop>
									           <source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs1.mp4" type='video/mp4' />
								           </video>
							             </div>
			      	  		  </div>
			      	  		  
			      	  	  </a>
			      	  	</li>
			      	  	
			      	  	<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-box-top">
			      	  		  		 <div class="perform-list-person-left"><img src="@/assets/anchor7.jpg" alt="" /></div>
			      	  		  	   <div class="perform-list-person-right">
			      	  		  		   <div class="perform-list-person-title">高迪<span>外贸经验丰富，货运专业。</span></div>
			      	  		  		   <div class="perform-list-person-info">中国国际海运网</div>
			      	  		  		   <div class="perform-order-num">当前已经有50人观看</div>
			      	  		  	   </div>
			      	  		  	</div>
			      	  		  	
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  		  	 
			      	  		  </div>
			      	  		  
			      	  		   <div class="perform-list-video">
                           <div class="mainVideoSmall">
								            <video class="video-js vjs-default-skin" controls preload="none" width="350" height="220" poster="@/assets/video9.jpg" loop>
									           <source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs7.mp4" type='video/mp4' />
								           </video>
							             </div>
			      	  		  </div>
			      	  	  </a>
			      	  	</li>
			      	  	
			      	  	<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-box-top">
			      	  		  		 <div class="perform-list-person-left"><img src="@/assets/anchor6.jpg" alt="" /></div>
			      	  		  	   <div class="perform-list-person-right">
			      	  		  		   <div class="perform-list-person-title">冯登智<span>湖南华光源海，货代人有一颗文艺心，善于原创歌曲，用原创说话，用原创表达，用原创证明货代人的芯子强。</span></div>
			      	  		  		   <div class="perform-list-person-info">中国国际海运网</div>
			      	  		  		   <div class="perform-order-num">当前已经有50人观看</div>
			      	  		  	   </div>
			      	  		  	</div>
			      	  		  	
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  		  	 
			      	  		  </div>
			      	  		  
			      	  		   <div class="perform-list-video">
                           <div class="mainVideoSmall">
								            <video class="video-js vjs-default-skin" controls preload="none" width="350" height="220" poster="@/assets/video10.jpg" loop>
									           <source src="http://expo.cn-bj.ufileos.com/biaoyan/cyzs5.mp4" type='video/mp4' />
								           </video>
							             </div>
			      	  		  </div>
			      	  	  </a>
			      	  	</li>

			      	  	<!--<li class="perform-list-menu">
			      	  		<a href="#">
			      	  		  <div class="perform-list-person">
			      	  		  	<div class="perform-list-person-left"><img src="@/assets/anchor4.jpg" alt="" /></div>
			      	  		  	<div class="perform-list-person-right">
			      	  		  		<div class="perform-list-person-title">丁芳<span>外贸经验丰富，货运专业。</span></div>
			      	  		  		<div class="perform-list-person-info">中国国际海运网</div>
			      	  		  	</div>
			      	  		  </div>
			      	  		  <div class="perform-person-order">
			      	  		  	 <div class="perform-order-num">当前已经有0人观看</div>
			      	  		  	 <div class="perform-order-btn">
			      	  		  	 	 <a href="" class="perform-btn-one">设置提醒</a>
			      	  		  	 	 <a href="" class="perform-btn-two">我要观看</a>
			      	  		  	 </div>
			      	  		  </div>
			      	  	  </a>
			      	  	</li>-->
			      	  </ul>
			      </div>
			      <div class="perform-tab-content hide"> 
			      	  	222
			      </div>
        </div>
     <!--备案tab切换页--end-->

    <footer-blogroll :language="language" />
    <count-down-dialog :wait-data="warnConten" :show.sync="warnVisible" />
  </div>
</template>

<script>
import navExhibition from "../../components/NavExhibition/index";
import footerBlogroll from "../../components/FooterBlogroll/footerBlogroll";
import { language } from "../../language/get";
import { init } from "../../common/socket";
import countDownDialog from "../../components/CountdownDialog";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  components: {
    navExhibition,
    footerBlogroll,
    countDownDialog
  },
  data() {
    return {
      language: language(),
      //socket弹窗
      warnConten: {},
      warnVisible: false
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      var that = this;
      init({ token: this.token }, onmessage);
      function onmessage(data) {
        that.clientId = data.data.client_id;
        console.log(data);
        if (data.data.type == "2") {
          that.warnConten = data.data;
          that.warnVisible = true;
        }
      }
    },
    download() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    goBack() {
      window.location.href = "/index.html";
    }
  }
};
</script>

<style scoped>
/*.about{
	background:#f2f2f2;
}*/
.about_content {
  margin-bottom: 210px;
}
.about_content_exh {
  width: 1200px;
  margin: auto;
}
.about_content_exh .breadcrumb {
  font-size: 14px;
  margin: 20px 0 30px 0;
}
.about_line {
  width: 100%;
  height: 2px;
  background: #f1f1f1;
  margin-top: 10px;
}
.about_title_img {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  margin-top: 20px;
}
.about_title {
  color: #333333;
  font-size: 14px;
  width: 732px;
}

/*tab切换--start--*/
.perform-forum-box {
	width:1200px;
  position: relative;
  margin:0 auto;
  margin-bottom:60px;
  margin-top:20px;
}
.perform-forum-tabs {
  border-bottom:1px solid #ccc;
  margin-bottom:20px;
  height:40px;
}
 
.perform-forum-tabs li {
  display: block;
  height:40px;
  line-height:40px;
 color: #a1a1a1;
 text-decoration: none;
 float:left;
 margin:0 20px;
 font-size:14px;
}
.perform-forum-tabs li:first-child{
	margin-left:0;
}
.tabs-active{
 	 color:#303133 !important;
 	 border-bottom:2px #f47900 solid;
}
 .perform-tab-content {
   width: 1200px;
 /*  height: 400px;*/
   font-size:18px;
   line-height: 1.5em;
   color: #666;
/*  background: #fff;*/
  }
  
 .hide{
 	display:none;
 }

/*主播列表*/
.perform-list-menu{
	padding:20px;
	background:#fff;
	overflow:hidden;
	margin-bottom:20px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
}
.perform-list-person{
	clear:both;
	overflow:hidden;
	width:750px;
	float:left;
}
.perform-box-top{
	clear:both;
	overflow:hidden;
}
.perform-list-video{
	width:350px;
	float:right;
}
.perform-list-person-left{
	height:130px;
	width:130px;
	float:left;
	background:#eee;
}
.perform-list-person-left img{
	height:130px;
	width:130px;
}
.perform-list-person-right{
	float:left;
	width:600px;
	margin-left:20px;
}
.perform-list-person-title{
	font-size:20px;
	color:#0f408a;
}
.perform-list-person-title span{
	margin-left:20px;
	line-height:28px;
}
.perform-list-person-info{
	color:#424242;
	margin-top:10px;
}

.perform-person-order{
	height:40px;
	margin-top:20px;
}
.perform-order-num{
	width:200px;
	font-size:14px;
	line-height:40px;
	float:left;
	color:#666;
	
}
.perform-order-btn{
	width:280px;
}
.perform-btn-one{
	width:130px;
	height:40px;
	line-height:40px;
	font-size:14px;
	float:left;
	background:#0f408a;
	color:#fff;
	border-radius:4px;
	text-align:center;
	margin-right:20px;
}
.perform-btn-two{
	width:130px;
	height:40px;
	line-height:40px;
	font-size:14px;
	float:left;
	background:#e6a23c;
	color:#fff;
	border-radius:4px;
	text-align:center;
}

/*tab切换--end--*/

/*--头部抬头文字--*/
.perform-main-content{
	width:1200px;
	margin:0 auto;
	clear:both;
	overflow:hidden;
	padding:30px 0;
}
.perform-main-title{
	font-size:20px;
	margin-bottom:10px;
	color:#0f408a;
	
}
.perform-main-time{
	margin-bottom:20px;
}
.perform-main-text{
	color:#666;
}
.perform-main-text p{
	margin-top:15px;
}
/*视频*/
.videolist {
		margin-top: 20px;
		clear:both;
		overflow:hidden;
		width:1200px;
		margin:0 auto;
	}
	
	.videolist li {
		width:590px;
		height:325px;
		float: left;
		margin-right:20px;
		margin-bottom:20px;
	}
	.videolist li:nth-child(2n){
		margin-right:0;
	}
	
	
.mainVideo {
		width:590px;
		height:325px;
		margin: 0 auto;
		margin-bottom:10px;
	}
.mainVideoSmall{
	width:350px;
	height:220px;
	margin: 0 auto;
}
</style>